import { CuratedProductListParametersType } from "@sellar-io/api-v2/types";
import { useNavigate } from "react-router";
import { useLocalStorage } from "usehooks-ts";
import { SPOTLIGHT } from "../../../../constants/routes";
import { useProductCuratedList } from "../../../../hooks/api/v2/product/useProductCuratedList";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { unAuthorisedUserPostcodeInLocalStorageKey } from "../../../discovery/v2/DiscoveryV2Home";
import { SpotlightProductCardImage } from "../../components/SharedCardComponents/SpotlightProductCardImage";
import { SpotlightSharedCardContainer } from "../../components/SharedCardComponents/SpotlightSharedCardContainer";
import { SupplierNameSection } from "./SupplierNameSection";

export const SpotlightBannerProducts = ({
  productIds,
  pageId,
  query,
  search,
}: {
  productIds?: number[];
  query?: CuratedProductListParametersType["query"];
  pageId: string;
  search?: string;
}) => {
  if (!productIds && !query && !search)
    throw new Error("Either ids or query must be provided");
  const navigate = useNavigate();
  const { business } = useSellarCurrentBusiness();
  const [unAuthorisedUserPostcode] = useLocalStorage<string | undefined>(
    unAuthorisedUserPostcodeInLocalStorageKey,
    undefined,
  );
  const buyerPostcode =
    business?.type === "retailer"
      ? business.DeliveryAddress.postalCode
      : undefined;
  const productListQuery = useProductCuratedList({
    retailerPostcode: buyerPostcode,
    unAuthorisedUserPostcode,
    query: [
      ...(query?.length ? [...query] : []),
      ...(productIds?.length
        ? ([
            {
              type: "id",
              modifier: "IN",
              value: productIds,
            },
          ] as const)
        : []),
    ],
    search,
    limit: 3,
    orderBy: "random",
  });

  const productList =
    productListQuery.data?.pages.flatMap((page) => page) ?? [];

  return (
    <>
      {productList.map((product) => (
        <SpotlightSharedCardContainer
          key={product.id}
          onClick={() =>
            navigate(
              `${SPOTLIGHT.href({ spotlightId: pageId })}?productId=${product.id}&type=featured`,
            )
          }
          className={"w-[200px]"}
        >
          <SpotlightProductCardImage
            product={product}
            showSupplierName={false}
            className={"h-[120px] rounded-lg"}
          />
          <SupplierNameSection
            supplierName={product.Supplier.Business.name}
            supplierLogo={product.Supplier.Business.logoUrl ?? ""}
          />
        </SpotlightSharedCardContainer>
      ))}
    </>
  );
};
